<template>
    <div class="apple-login-button">
        <button
            class="btn btn-apple"
            @click.prevent="onClick"
        >
            <img src="/img/icons/apple-logo.svg" alt="Apple">
            <span>{{ lang.labels.apple|capitalize }}</span>
        </button>
    </div>
</template>

<script>
import crypto from 'crypto';
import { get } from 'lodash';

export default {
    data() {
        return {
            state: null,
            apple_script: null,
        }
    },

    computed: {
        lang() {
            return this.$root.lang.login_form
        },
    },

    mounted() {
        this.apple_script = document.createElement('script')
        this.apple_script.setAttribute('id', 'apple_id_script');
        this.apple_script.setAttribute('src', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js')
        document.head.appendChild(this.apple_script);

        // Listen for authorization success.
        document.addEventListener('AppleIDSignInOnSuccess', this.AppleIDSignInOnSuccess);

        // Listen for authorization failures.
        document.addEventListener('AppleIDSignInOnFailure', this.AppleIDSignInOnFailure);
    },

    beforeDestroy() {
        document.removeEventListener('AppleIDSignInOnSuccess', this.AppleIDSignInOnSuccess);
        document.removeEventListener('AppleIDSignInOnFailure', this.AppleIDSignInOnFailure);
        document.head.removeChild(this.apple_script);
    },

    methods: {
        login(id_token) {
            isLoading()

            axios.post('/api/apple-login', {
                token: id_token
            })
            .then(({data}) => {
                stopLoading()

                this.$emit('signedin', data)
            })
            .catch(response => {
                stopLoading()

                window.events.$emit('hideModal', { name: 'login' })

                alert('Errore nel login tramite Apple')
            })
        },

        onClick() {
            this.state = crypto.randomBytes(16).toString('hex');
            AppleID.auth.init({
                clientId : process.env.MIX_APPLE_CLIENT_ID,
                scope : 'name email',
                redirectURI : window.app_url + 'callback',
                state : this.state,
                usePopup : true,
            });

            AppleID.auth.signIn();
            return false;
        },

        AppleIDSignInOnSuccess(event) {
            // Handle successful response.
            if(this.state == get(event.detail, 'authorization.state'))
            {
                this.state = null;
                this.login(get(event.detail, 'authorization.id_token'))
            }
        },

        AppleIDSignInOnFailure(event) {
            // Handle error.
            flash(
                get(
                    this.$root.lang,
                    'login_form.sso.apple.' + event.detail.error, 
                    get(
                        this.$root.lang,
                        'login_form.sso.failure',
                        'sso.failed'
                    )
                ),
                'warning'
            )
            this.state = null;
        },

    },
}
</script>